export default "__VITE_ASSET__302ee130__"